import { render, staticRenderFns } from "./LandingMerchantFeatures.vue?vue&type=template&id=186b15fe"
import script from "./LandingMerchantFeatures.vue?vue&type=script&lang=js"
export * from "./LandingMerchantFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports